import { renderTemplate, renderTemplateFromJson } from "../index";
import type { RenderContext, RenderResult } from "../types/render";
import type { CompiledTemplate, LabelTemplateV2 } from "../types/template";
import { type PrintZplOptions, printZpl } from "./send";

type BrowserPrintTargetOptions = Omit<PrintZplOptions, "zpl">;

export interface RenderAndPrintTemplateOptions
  extends BrowserPrintTargetOptions {
  template: LabelTemplateV2;
  vars: Record<string, unknown>;
  context: RenderContext;
}

export interface RenderAndPrintCompiledOptions
  extends BrowserPrintTargetOptions {
  compiled: CompiledTemplate;
  vars: Record<string, unknown>;
  context: RenderContext;
}

export interface RenderAndPrintResult {
  zpl: string;
  deviceName: string;
  bytesSent: number;
  render: RenderResult;
}

export async function renderAndPrintTemplate(
  options: RenderAndPrintTemplateOptions,
): Promise<RenderAndPrintResult> {
  const render = renderTemplateFromJson(
    options.template,
    options.vars,
    options.context,
  );
  const print = await printZpl({
    ...options,
    zpl: render.zpl,
  });

  return {
    zpl: render.zpl,
    deviceName: print.deviceName,
    bytesSent: print.bytesSent,
    render,
  };
}

export async function renderAndPrintCompiled(
  options: RenderAndPrintCompiledOptions,
): Promise<RenderAndPrintResult> {
  const render = renderTemplate(
    options.compiled,
    options.vars,
    options.context,
  );
  const print = await printZpl({
    ...options,
    zpl: render.zpl,
  });

  return {
    zpl: render.zpl,
    deviceName: print.deviceName,
    bytesSent: print.bytesSent,
    render,
  };
}
